import React from 'react';
import { Brain, Sparkles, TrendingUp, AlertCircle } from 'lucide-react';

const AIInsightsTab = () => {
  return (
    <div className="space-y-6">
      {/* Smart Assistant Card */}
      <div className="bg-white rounded-lg p-6 shadow-md">
        <div className="flex items-center gap-2 mb-4">
          <Brain className="h-6 w-6 text-indigo-500" />
          <h3 className="text-lg font-semibold">Smart Assistant</h3>
        </div>
        <div className="space-y-6">
          {[
            {
              icon: <Sparkles className="h-5 w-5 text-green-500" />,
              title: "Potential Savings Opportunity",
              description: "Based on your usage patterns, you could save $25/month by downgrading your Netflix plan.",
              action: "Review Netflix Plan"
            },
            {
              icon: <TrendingUp className="h-5 w-5 text-blue-500" />,
              title: "Spending Trend Alert",
              description: "Your entertainment category spending has increased by 15% this month.",
              action: "View Details"
            },
            {
              icon: <AlertCircle className="h-5 w-5 text-yellow-500" />,
              title: "Subscription Overlap",
              description: "You have multiple streaming services with similar content.",
              action: "Compare Services"
            }
          ].map((insight, index) => (
            <div key={index} className="flex gap-4 pb-6 border-b last:border-b-0 last:pb-0">
              <div className="flex-shrink-0 mt-1">{insight.icon}</div>
              <div className="flex-grow">
                <h4 className="font-semibold mb-1">{insight.title}</h4>
                <p className="text-sm text-gray-600 mb-3">{insight.description}</p>
                <button 
                  className="text-sm text-indigo-600 hover:text-indigo-700 font-medium"
                  onClick={() => {/* Add action handler */}}
                >
                  {insight.action} →
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Financial Health Score */}
      <div className="bg-white rounded-lg p-6 shadow-md">
        <h3 className="text-lg font-semibold mb-4">Financial Health Score</h3>
        <div className="text-center mb-6">
          <div className="text-4xl font-bold text-indigo-600 mb-2">78/100</div>
          <div className="w-full bg-gray-200 rounded-full h-2.5 mb-4">
            <div className="bg-indigo-600 h-2.5 rounded-full" style={{ width: '78%' }}></div>
          </div>
          <p className="text-sm text-gray-600">Your subscription management is better than 65% of users</p>
        </div>
        <div className="space-y-4">
          <h4 className="font-medium">Improvement Tips:</h4>
          <ul className="space-y-2 text-sm text-gray-600">
            <li className="flex items-center gap-2">
              <div className="w-1.5 h-1.5 bg-indigo-600 rounded-full"></div>
              Consider consolidating your streaming services
            </li>
            <li className="flex items-center gap-2">
              <div className="w-1.5 h-1.5 bg-indigo-600 rounded-full"></div>
              Review and cancel unused subscriptions
            </li>
            <li className="flex items-center gap-2">
              <div className="w-1.5 h-1.5 bg-indigo-600 rounded-full"></div>
              Set up auto-payments to avoid late fees
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AIInsightsTab;